import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_17826_173665)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M7.68438 10.5238L8.28321 3.10328V-0.000244141H5.71729V3.10328L6.35002 10.5238H7.68438Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M5.80957 12.042H8.19069V13.9998H5.80957V12.042Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_17826_173665",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgExclamation;
